import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useSiteContent } from "@/context/SiteContentContext";

export default function Testimonials() {
  const { content } = useSiteContent();
  const t = content?.testimonials || {};
  const quotes = t.quotes || [];

  return (
    <section data-testid="testimonials-section" className="relative section-pad bg-bg overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <p className="text-xs tracking-[0.4em] uppercase text-[color:var(--gold-hi)]">{t.eyebrow}</p>
        <h2 className="mt-6 font-serif-display text-5xl md:text-7xl leading-[1.02] text-cream max-w-3xl">
          {t.title_line_1} <span className="italic gold-ink">{t.title_line_2}</span>
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-6 md:gap-8">
          {quotes.map((q, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              data-testid={`testimonial-card-${i}`}
              className="rounded-2xl p-8 backdrop-blur-xl border border-warm"
              style={{ background: "rgba(61,35,23,0.35)" }}
            >
              <Quote className="text-[color:var(--gold-hi)]" size={26} />
              <blockquote className="mt-5 font-serif-display italic text-2xl text-cream leading-snug">
                &ldquo;{q.q}&rdquo;
              </blockquote>
              <figcaption className="mt-8 border-t border-warm pt-4 text-sm">
                <div className="text-cream">{q.n}</div>
                <div className="text-muted-warm text-xs tracking-[0.3em] uppercase mt-1">{q.r}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
